import { render } from "./video-with-instructions-v1.vue?vue&type=template&id=f6455b9a&scoped=true"
import script from "./video-with-instructions-v1.vue?vue&type=script&lang=js"
export * from "./video-with-instructions-v1.vue?vue&type=script&lang=js"

import "./video-with-instructions-v1.vue?vue&type=style&index=0&id=f6455b9a&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6455b9a"]])

export default __exports__